import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ControleEstoqueService } from '../../../../../shared/services/apis/produto/controle-estoque.service';
import { ControleEstoqueHistoricoSerieStruct } from '../../../../../shared/services/structs/produto/controle-estoque-historico-serie.struct';
import { LoadingBoxDefaultListComponent } from '../../../../../shared/components/loading-box-default-list/loading-box-default-list.component';

export interface HistoricoSerieDialogData {
  idProduto: number;
  idSerie: number;
  numeroSerie: string;
}

@Component({
  selector: 'app-historico-serie-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, LoadingBoxDefaultListComponent],
  templateUrl: './historico-serie-dialog.component.html',
  styleUrls: ['./historico-serie-dialog.component.css'],
})
export class HistoricoSerieDialogComponent implements OnInit {
  public lista: ControleEstoqueHistoricoSerieStruct[] = [];
  public total: number = 0;
  public loading: boolean = false;
  
  private paginaAtual: number = 0;
  private tamanhoPagina: number = 20;

  constructor(
    public dialogRef: MatDialogRef<HistoricoSerieDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HistoricoSerieDialogData,
    private controleEstoqueService: ControleEstoqueService
  ) {}

  ngOnInit(): void {
    this.carregarHistorico();
  }

  public carregarHistorico(): void {
    this.loading = true;
    
    const request = {
      paginaAtual: this.paginaAtual,
      tamanhoPagina: this.tamanhoPagina
    };

    this.controleEstoqueService.getHistoricoSerie(this.data.idProduto, this.data.idSerie, request).subscribe(
      (response) => {
        if (!response.isError) {
          this.lista = [...this.lista, ...(response.list || [])];
          this.total = response.fullListSize || 0;
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  public loadMore(): void {
    this.paginaAtual++;
    this.carregarHistorico();
  }

  public fechar(): void {
    this.dialogRef.close();
  }
}
